import { BookingHistoryDataGrid } from '../../../grids/BookingHistoryDataGrid';

const BookingHistoryTab = () => {
  return <BookingHistoryDataGrid />;
};

BookingHistoryTab.displayName = 'BookingHistoryTab';
export default BookingHistoryTab;
